import React from "react"
import "./UseAiContentToggle.style.scss"

interface UseAiContentToggleProps {
  checked: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
}

const UseAiContentToggle = ({
  checked,
  disabled = false,
  onChange,
}: UseAiContentToggleProps) => (
  <label className={`use-ai-content-toggle${checked ? " is-on" : ""}`}>
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
    <span>
      <strong>Use AI for some questions</strong>
      <span className="use-ai-content-toggle__help">
        About half from your library, the rest generated for this paper only.
      </span>
    </span>
  </label>
)

export default UseAiContentToggle
